export interface ComicItem {
  id: string;
  title: string;
  author: string;
  coverImage: string;
  category: string;
  status: 'ongoing' | 'completed';
  description: string;
  rating: number;
  chapters: number;
  updateDate: string;
  tags: string[];
}

export const comicCategories = [
  { slug: 'romance', name: '恋爱', icon: 'ri-heart-line' },
  { slug: 'fantasy', name: '奇幻', icon: 'ri-magic-line' },
  { slug: 'campus', name: '校园', icon: 'ri-book-open-line' },
  { slug: 'action', name: '动作', icon: 'ri-flashlight-line' },
  { slug: 'thriller', name: '悬疑', icon: 'ri-search-eye-line' },
  { slug: 'comedy', name: '搞笑', icon: 'ri-emotion-laugh-line' },
];

export const hotComics: ComicItem[] = [
  {
    id: 'comic-001',
    title: '蜜糖公主的奇幻旅程',
    author: '金智秀',
    coverImage: 'https://readdy.ai/api/search-image?query=Cute%20Korean%20manhwa%20webtoon%20cover%20art%2C%20romantic%20fantasy%20style%2C%20pastel%20pink%20and%20cream%20background%2C%20beautiful%20anime%20girl%20with%20long%20flowing%20hair%20in%20elegant%20princess%20dress%2C%20soft%20dreamy%20atmosphere%2C%20sparkling%20magical%20effects%2C%20clean%20illustration%20style%20with%20delicate%20linework%2C%20shojo%20manga%20aesthetic%2C%20warm%20gentle%20color%20palette&width=600&height=800&seq=comic-cover-001&orientation=portrait',
    category: '恋爱',
    status: 'ongoing',
    description: '平凡女孩意外穿越到魔法王国，与冷酷王子展开一段甜蜜浪漫的奇幻冒险。',
    rating: 9.6,
    chapters: 48,
    updateDate: '2026-07-06',
    tags: ['穿越', '王室', '甜蜜', '魔法'],
  },
  {
    id: 'comic-002',
    title: '校园心动日记',
    author: '李恩智',
    coverImage: 'https://readdy.ai/api/search-image?query=Cute%20Korean%20webtoon%20school%20romance%20cover%2C%20two%20high%20school%20students%20in%20uniform%20shyly%20looking%20at%20each%20other%2C%20cherry%20blossom%20petals%20falling%2C%20soft%20pastel%20pink%20background%2C%20spring%20campus%20setting%2C%20warm%20sunlight%2C%20delicate%20shojo%20art%20style%2C%20gentle%20color%20palette%2C%20clean%20illustration&width=600&height=800&seq=comic-cover-002&orientation=portrait',
    category: '校园',
    status: 'ongoing',
    description: '学霸班长与转校生之间青涩甜蜜的校园恋爱故事，每天都是心动的感觉。',
    rating: 9.5,
    chapters: 36,
    updateDate: '2026-07-05',
    tags: ['校园', '青春', '甜蜜', '日更'],
  },
  {
    id: 'comic-003',
    title: '暗夜侦探录',
    author: '朴志成',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20mystery%20thriller%20cover%20art%2C%20detective%20theme%2C%20dark%20alley%20with%20moonlight%2C%20stylish%20young%20detective%20in%20trench%20coat%2C%20mysterious%20atmosphere%2C%20noir%20aesthetic%2C%20warm%20amber%20streetlight%2C%20soft%20shadows%2C%20clean%20illustration%20style%2C%20webtoon%20cover%20design&width=600&height=800&seq=comic-cover-003&orientation=portrait',
    category: '悬疑',
    status: 'ongoing',
    description: '天才高中生侦探在深夜揭开城市隐藏的秘密，每个案件都扣人心弦。',
    rating: 9.7,
    chapters: 52,
    updateDate: '2026-07-06',
    tags: ['悬疑', '推理', '都市', '高智商'],
  },
  {
    id: 'comic-004',
    title: '异世界冒险团',
    author: '崔敏浩',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20fantasy%20adventure%20manhwa%20cover%2C%20group%20of%20young%20heroes%20with%20magical%20weapons%2C%20epic%20fantasy%20world%20background%2C%20castles%20and%20dragons%20in%20distance%2C%20warm%20color%20palette%2C%20adventure%20theme%2C%20clean%20webtoon%20illustration%20style%2C%20soft%20pastel%20accents&width=600&height=800&seq=comic-cover-004&orientation=portrait',
    category: '奇幻',
    status: 'ongoing',
    description: '五个少年意外获得神秘力量，组队踏上拯救异世界的冒险之旅。',
    rating: 9.4,
    chapters: 44,
    updateDate: '2026-07-04',
    tags: ['冒险', '团队', '魔法', '热血'],
  },
  {
    id: 'comic-005',
    title: '我的猫系男友',
    author: '韩素英',
    coverImage: 'https://readdy.ai/api/search-image?query=Cute%20Korean%20romantic%20comedy%20manhwa%20cover%2C%20handsome%20boy%20with%20cat%20ears%20and%20tail%2C%20shy%20girl%20blushing%2C%20cozy%20apartment%20background%2C%20warm%20pastel%20pink%20and%20cream%20tones%2C%20adorable%20chibi%20style%20elements%2C%20soft%20romantic%20atmosphere%2C%20clean%20webtoon%20illustration&width=600&height=800&seq=comic-cover-005&orientation=portrait',
    category: '恋爱',
    status: 'completed',
    description: '捡到的小猫咪竟然变成了超级帅哥？甜蜜又好笑的同居恋爱日常。',
    rating: 9.8,
    chapters: 80,
    updateDate: '2026-06-30',
    tags: ['恋爱', '搞笑', '奇幻', '日常'],
  },
];

export const editorPickComics: ComicItem[] = [
  {
    id: 'comic-006',
    title: '公主殿下的秘密',
    author: '张美英',
    coverImage: 'https://readdy.ai/api/search-image?query=Elegant%20Korean%20manhwa%20royal%20romance%20cover%2C%20beautiful%20princess%20in%20magnificent%20gown%20holding%20a%20secret%20letter%2C%20palace%20interior%20background%2C%20soft%20golden%20and%20pink%20lighting%2C%20dreamy%20romantic%20atmosphere%2C%20delicate%20shojo%20art%20style%2C%20clean%20illustration&width=600&height=800&seq=comic-cover-006&orientation=portrait',
    category: '恋爱',
    status: 'ongoing',
    description: '公主殿下隐藏着不为人知的身份，在宫廷阴谋与爱情之间寻找真相。',
    rating: 9.6,
    chapters: 32,
    updateDate: '2026-07-06',
    tags: ['王室', '恋爱', '秘密', '宫廷'],
  },
  {
    id: 'comic-007',
    title: '武林高手在校园',
    author: '郑宇成',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20action%20comedy%20manhwa%20cover%2C%20martial%20arts%20student%20in%20school%20uniform%20showing%20cool%20kung%20fu%20pose%2C%20modern%20school%20background%2C%20dynamic%20action%20lines%2C%20warm%20afternoon%20lighting%2C%20clean%20webtoon%20illustration%20style%2C%20energetic%20composition&width=600&height=800&seq=comic-cover-007&orientation=portrait',
    category: '动作',
    status: 'ongoing',
    description: '隐世武林高手转学到普通高中，用绝世武功解决校园里的各种麻烦。',
    rating: 9.3,
    chapters: 56,
    updateDate: '2026-07-05',
    tags: ['武侠', '校园', '搞笑', '热血'],
  },
  {
    id: 'comic-008',
    title: '星空下的约定',
    author: '赵恩惠',
    coverImage: 'https://readdy.ai/api/search-image?query=Romantic%20Korean%20manhwa%20starry%20night%20cover%2C%20young%20couple%20sitting%20on%20hilltop%20watching%20stars%2C%20beautiful%20night%20sky%20with%20shooting%20stars%2C%20warm%20cozy%20atmosphere%2C%20soft%20blue%20and%20pink%20twilight%20tones%2C%20clean%20shojo%20illustration%20style%2C%20dreamy%20romantic%20mood&width=600&height=800&seq=comic-cover-008&orientation=portrait',
    category: '恋爱',
    status: 'completed',
    description: '青梅竹马的两人在星空下许下约定，十年后的重逢让一切重新开始。',
    rating: 9.9,
    chapters: 60,
    updateDate: '2026-06-28',
    tags: ['青梅竹马', '重逢', '治愈', '星空'],
  },
];

export const weeklyNewComics: ComicItem[] = [
  {
    id: 'comic-009',
    title: '甜品店的魔法师',
    author: '尹彩媛',
    coverImage: 'https://readdy.ai/api/search-image?query=Cute%20Korean%20manhwa%20dessert%20bakery%20theme%20cover%2C%20pretty%20girl%20baker%20holding%20magical%20sparkling%20cake%2C%20cozy%20bakery%20interior%20background%2C%20warm%20pastel%20pink%20and%20cream%20tones%2C%20sweet%20delicious%20pastries%2C%20soft%20dreamy%20atmosphere%2C%20clean%20webtoon%20illustration&width=600&height=800&seq=comic-cover-009&orientation=portrait',
    category: '奇幻',
    status: 'ongoing',
    description: '在甜品店打工的女孩发现自己的烘焙有神奇魔力，每一道甜点都能治愈人心。',
    rating: 9.5,
    chapters: 12,
    updateDate: '2026-07-06',
    tags: ['美食', '治愈', '魔法', '日常'],
  },
  {
    id: 'comic-010',
    title: '电竞女王归来',
    author: '金泰亨',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20esports%20gaming%20theme%20cover%2C%20cool%20female%20gamer%20with%20headset%20and%20gaming%20gear%2C%20neon%20cyber%20arena%20background%2C%20dynamic%20energetic%20composition%2C%20warm%20accent%20lights%2C%20clean%20webtoon%20illustration%20style%2C%20modern%20aesthetic&width=600&height=800&seq=comic-cover-010&orientation=portrait',
    category: '动作',
    status: 'ongoing',
    description: '退役三年的电竞女王重返赛场，用实力证明自己依然是巅峰。',
    rating: 9.4,
    chapters: 18,
    updateDate: '2026-07-05',
    tags: ['电竞', '热血', '逆袭', '竞技'],
  },
  {
    id: 'comic-011',
    title: '鬼怪便利店',
    author: '沈智恩',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20supernatural%20comedy%20manhwa%20cover%2C%20quirky%20convenience%20store%20at%20night%2C%20cute%20ghost%20characters%20shopping%2C%20warm%20neon%20store%20lights%2C%20playful%20spooky%20atmosphere%2C%20clean%20webtoon%20illustration%20style%2C%20soft%20pastel%20accents%2C%20charming%20character%20design&width=600&height=800&seq=comic-cover-011&orientation=portrait',
    category: '搞笑',
    status: 'ongoing',
    description: '深夜便利店来了各种奇怪的鬼怪客人，店员的爆笑日常就此展开。',
    rating: 9.2,
    chapters: 24,
    updateDate: '2026-07-04',
    tags: ['搞笑', '灵异', '日常', '治愈'],
  },
];

export const allComics: ComicItem[] = [
  ...hotComics,
  ...editorPickComics,
  ...weeklyNewComics,
  {
    id: 'comic-012',
    title: '实习死神日记',
    author: '文智雅',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20dark%20fantasy%20comedy%20manhwa%20cover%2C%20cute%20grim%20reaper%20girl%20in%20black%20robe%20holding%20scythe%2C%20ethereal%20moonlit%20background%2C%20contrast%20of%20dark%20and%20pastel%20pink%20accents%2C%20clean%20webtoon%20illustration%20style%2C%20charming%20character%20design%2C%20soft%20dreamy%20atmosphere&width=600&height=800&seq=comic-cover-012&orientation=portrait',
    category: '奇幻',
    status: 'ongoing',
    description: '新手死神第一次执行任务就出了岔子，与人类少年展开一段奇妙的缘分。',
    rating: 9.3,
    chapters: 30,
    updateDate: '2026-07-03',
    tags: ['死神', '奇幻', '治愈', '成长'],
  },
  {
    id: 'comic-013',
    title: '恋爱暴走中',
    author: '黄秀晶',
    coverImage: 'https://readdy.ai/api/search-image?query=Cute%20Korean%20romantic%20comedy%20manhwa%20cover%2C%20energetic%20girl%20chasing%20after%20shy%20boy%2C%20colorful%20school%20hallway%20background%2C%20exaggerated%20funny%20expressions%2C%20bright%20pastel%20colors%2C%20dynamic%20composition%2C%20clean%20webtoon%20illustration%20style%2C%20playful%20mood&width=600&height=800&seq=comic-cover-013&orientation=portrait',
    category: '恋爱',
    status: 'ongoing',
    description: '元气少女倒追高冷学长，一场笑料百出的恋爱大作战。',
    rating: 9.1,
    chapters: 40,
    updateDate: '2026-07-05',
    tags: ['恋爱', '搞笑', '校园', '倒追'],
  },
  {
    id: 'comic-014',
    title: '末日生存法则',
    author: '姜道贤',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20post%20apocalyptic%20survival%20manhwa%20cover%2C%20group%20of%20survivors%20in%20ruined%20cityscape%2C%20dramatic%20sunset%20lighting%2C%20determined%20expressions%2C%20warm%20amber%20sky%2C%20clean%20webtoon%20illustration%20style%2C%20cinematic%20composition%2C%20hopeful%20atmosphere&width=600&height=800&seq=comic-cover-014&orientation=portrait',
    category: '悬疑',
    status: 'ongoing',
    description: '末日降临，一群普通人如何在废墟中求生，揭露灾难背后的真相。',
    rating: 9.5,
    chapters: 35,
    updateDate: '2026-07-06',
    tags: ['末日', '生存', '悬疑', '人性'],
  },
];

export const mockComicDetail: ComicItem = {
  id: 'comic-001',
  title: '蜜糖公主的奇幻旅程',
  author: '金智秀',
  coverImage: 'https://readdy.ai/api/search-image?query=Luxurious%20Korean%20manhwa%20romantic%20fantasy%20detail%20illustration%2C%20beautiful%20princess%20in%20magnificent%20gown%20standing%20in%20magical%20garden%2C%20sparkling%20fairy%20dust%2C%20elegant%20palace%20in%20background%2C%20soft%20warm%20golden%20and%20pink%20lighting%2C%20dreamy%20atmosphere%2C%20clean%20shojo%20illustration%20style%2C%20highly%20detailed%2C%20romantic%20mood&width=800&height=1066&seq=comic-detail-001&orientation=portrait',
  category: '恋爱',
  status: 'ongoing',
  description: '平凡女孩林小桃意外穿越到魔法王国艾斯特拉，发现自己竟然与传说中的蜜糖公主长得一模一样。为了回到现实世界，她必须代替真正的公主完成与冷酷王子亚历克斯的婚约。然而在相处的过程中，冷酷王子的内心逐渐被她的善良融化，一场跨越两个世界的甜蜜奇幻爱情故事就此展开。随着剧情深入，隐藏的宫廷阴谋也逐渐浮出水面……',
  rating: 9.6,
  chapters: 48,
  updateDate: '2026-07-06',
  tags: ['穿越', '王室', '甜蜜', '魔法', '奇幻爱情'],
};

export const aboutMilestones = [
  {
    year: '2023',
    title: '平台创立',
    description: '桃桃漫画网正式上线，首批引入200+部韩漫作品，为读者提供免费无删减阅读服务。',
  },
  {
    year: '2024',
    title: '百万用户',
    description: '注册用户突破100万，日活跃读者超过30万，成为韩漫爱好者首选平台。',
  },
  {
    year: '2025',
    title: '内容升级',
    description: '漫画库扩展至5000+部，全面支持无删减下拉式阅读，优化移动端体验。',
  },
  {
    year: '2026',
    title: '行业领先',
    description: '成为华语地区领先的韩漫阅读平台，持续优化阅读体验，打造漫画社区。',
  },
];